import { useSelector } from 'react-redux';

import { Input } from '@/components/Input';
import {
    IMotorVehicle,
    selectMotorVehicleActiveIndex,
    selectMotorVehiclebyIndex,
    setMotorVehicleByIndex,
} from '@/context/borrower';
// eslint-disable-next-line no-restricted-imports
// import { ICreditCard } from '@/context/borrower/types/creditCardsTypes';
import { RootState } from '@/context/store';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { getNumber } from '@/utils/valueFormat';

export interface IProps {
    baseId: string;
    showErrors: boolean;
    setShowErrors: (value: boolean) => void;
}

export const testId = 'MotorVehicleLoanBalance';

export function MotorVehicleLoanBalance({
    baseId,
    showErrors,
    setShowErrors,
}: IProps): JSX.Element {
    // ***** Redux *****
    const activeMotorVehicelIndex = useAppSelector(
        selectMotorVehicleActiveIndex
    );
    const motorVehicle = useSelector((state: RootState) =>
        selectMotorVehiclebyIndex(state, activeMotorVehicelIndex)
    );
    const loanBalance = motorVehicle?.loanBalance;
    const dispatch = useAppDispatch();
    // ***** Event Handlers *****
    function handleChange(value: string | boolean): void {
        setShowErrors(false);
        if (motorVehicle === null) return;
        if (typeof value !== 'string') return;
        const MAXIMUM = 999999;
        const intValue: number | undefined = getNumber(value, MAXIMUM);
        if (intValue && intValue > 9999999) return;
        if (motorVehicle === null) return;

        const newMotorVehicle: IMotorVehicle = {
            ...motorVehicle,
            loanBalance: intValue,
        };
        if (intValue && isNaN(intValue)) {
            newMotorVehicle.loanBalance = undefined;
        }
        dispatch(
            setMotorVehicleByIndex({
                index: activeMotorVehicelIndex,
                motorVehicle: newMotorVehicle,
            })
        );
    }

    // ***** Render *****
    return (
        <div data-testid={testId}>
            <Input
                title='Balance'
                placeholder='18,000'
                showErrors={showErrors && !loanBalance}
                onChange={handleChange}
                id={`${baseId}-input-loanBalance`}
                value={loanBalance?.toLocaleString() ?? ''}
                prefix='$'
                showNumpad={true}
            />
        </div>
    );
}
